import * as ActionTypes from './types.action';

export const resetRefundStatus = () => ({
  type: ActionTypes.SEND_REFUND_EMAIL_RESET,
});

export const resetAllStatus = () => ({
  type: ActionTypes.RESET_STATUS_SUCCESS,
});
